import { localDateToString } from "@shared/utils/formatters/dates"
import { Status } from "@shared/types"
import { LegacyFleetEntry } from "@shared/utils/compatibility"
import { FleetEntry } from "../../api/fleet"
import { abiGroupTransform } from "../confirmChanges/components/tables/tableData/changedVehiclesTableData"
import { FILTER_ITEMS } from "./config"

export type FleetListData = Omit<FleetEntry, "onCoverDate" | "offCoverDate" | "sentToMID"> & {
  abiGroupString: string
  offCoverDate: string | null
  onCoverDate: string
  rowIndex: number
  sentToMID: string | null
}

export const makeData = (vehicles: ReadonlyArray<FleetEntry>): ReadonlyArray<FleetListData> =>
  vehicles.map((it, i) => ({
    ...it,
    abiGroupString: abiGroupTransform(it.abiGroup, it.type),
    offCoverDate: it.offCoverDate ? localDateToString(it.offCoverDate) : null,
    onCoverDate: localDateToString(it.onCoverDate),
    rowIndex: i,
    sentToMID: it?.sentToMID ? localDateToString(it.sentToMID) : null,
  }))

export const onFilter = (data: ReadonlyArray<FleetListData>, filterTerm: Status | null) => {
  if (data.length === 0 || !filterTerm) return data
  if (filterTerm === `scheduled`) return data.filter((it) => it.status === `scheduled`)
  if (filterTerm === `on_cover`) return data.filter((it) => it.status === `on_cover`)
  if (filterTerm === `off_cover`) return data.filter((it) => it.status === `off_cover`)
  return data
}

interface CSVFleetEntry {
  Make: string
  Model: string
  Registration: string
  ABI: string
  "On cover from": string
  "On cover until": string
  "Sent to MID": string
  Status: string
  Connected: string
  "Date Added": string
}

export const formatForCSV = (fleetEntry: LegacyFleetEntry): CSVFleetEntry => ({
  Make: fleetEntry.make ?? ``,
  Model: fleetEntry.model ?? ``,
  Registration: fleetEntry.registrationNumber ?? ``,
  ABI: abiGroupTransform(fleetEntry.abiGroup, fleetEntry.type),
  "On cover from": fleetEntry.onCoverDate ?? ``,
  "On cover until": fleetEntry.offCoverDate ?? ``,
  "Sent to MID": fleetEntry.sentToMID ?? ``,
  Status: (FILTER_ITEMS.find((n) => n.value === fleetEntry.status)?.text || fleetEntry.status) ?? ``,
  Connected: fleetEntry.isConnected ? `Yes` : `No`,
  "Date Added": fleetEntry.createdAt ?? ``,
})
